import { MediaFileKind } from "@next-platform/client-common-core";
import { IconVariants } from "@next-platform/client-common-spicy-ui";

const mediaFileKindIcons: Record<MediaFileKind, IconVariants> = {
  [MediaFileKind.UPLOADED]: IconVariants.UPLOAD,
  [MediaFileKind.CHARACTER_AVATAR]: IconVariants.SQUARE_USER_ROUND,
  [MediaFileKind.PERSONA_AVATAR]: IconVariants.VENETIAN_MASK,
  [MediaFileKind.USER_AVATAR]: IconVariants.USER,
  [MediaFileKind.CONVERSATION_IMAGE]: IconVariants.MESSAGE_CIRCLE,
  [MediaFileKind.LOREBOOK_AVATAR]: IconVariants.BOOK_TEXT,
  // No type yet, so the default image icon.
  [MediaFileKind.UNATTACHED]: IconVariants.IMAGE,
};

export default mediaFileKindIcons;
